import { roundToCents } from '../accounts-receivable/round-to-cents.js';
import { computePromotionCreditLineAmount, } from './compute-promotion-credit-line-amount.js';
/** The credit amount a set of lines adds up to: each line rounded to cents, then summed. */
export function sumCreditLineAmounts(lines) {
    return roundToCents(lines.reduce((sum, line) => sum.plus(computePromotionCreditLineAmount(line)), roundToCents(0)));
}
//# sourceMappingURL=sum-credit-line-amounts.js.map